import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AgencyAdminRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen grid place-items-center bg-[#F8F9FA]">
        <div className="text-sm text-[#6C757D]">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin" && user.role !== "agency_admin")
    return <Navigate to="/dashboard" replace />;
  return children;
}
